<template>
<div>
    <div class="p-2 upper-fringe w-full" v-if="!isActive && upperBand" >{{$t('headerMessage')}}</div>
    <div class="header z-40 flex items-center" id="header" :class="[currentColor, isActive ? 'open' : 'header-top', isBanner ? 'h-40' : '']">
        <banner-header class="absolute top-0 right-0 left-0" :banner="banner"></banner-header>
        <div class="header-container">
            <div class="header-logo">
                <a href="/">
                    <img
                        class="logo-operegrino"
                        :src="'/images/logo/logo_' + (isActive ? 'rouge' : currentColor) + '.png'"
                        alt="logo-header"
                    />
                </a>
            </div>

            <div class="flex items-center">
                <a
                    v-if="currentRoute !== 'wizard'"
                    v-ripple
                    :href="routes.wizard"
                    class="btn btn-reservation"
                    :class="[
                        currentColor === 'white'
                            ? 'btn-white btn-white__outlined'
                            : 'btn-outline-primary',
                        isActive ? 'opacity-0' : 'opacity-100'
                    ]"
                >
                    <span>{{ $t("reserve") }}</span>
                </a>
                <a v-if="currentRoute === 'wizard'" :href="routes.contact"  v-ripple class="btn btn-outline-primary mr-5 lg:mr-0">
                    {{ $t("contact") }}
                </a>
                <div
                    id="hamburger-icon"
                    @click="toggleMenu"
                    :class="[currentColor, isActive ? 'open' : '', currentRoute === 'wizard' ? 'lg:hidden' : '']"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <a v-if="currentRoute === 'wizard'" class="language-selector-link hidden lg:flex items-center nv-link relative" :class="currentColor">
                    <span class="mr-2">{{ localeFormat }}</span>
                    <icon-caret></icon-caret>
                    <div class="language-selector absolute rounded">
                        <slot name="language-selector"></slot>
                    </div>
                </a>
            </div>
        </div>

        <side-menu
            :is-active="isActive"
            :close-menu="closeMenu"
        >
            <side-menu-content :routes="routes" :username="user && user.name">
                <template v-slot:language-selector-mobile>
                    <slot name="language-selector-mobile"></slot>
                </template>
            </side-menu-content>
        </side-menu>
    </div>
</div>    
</template>
<script>
import vhCheck from "vh-check";
import axios from 'axios'
const whiteAsDefault = ["home"];
import SideMenu from "./SideMenu";
import SideMenuContent from "./SideMenuContent";
import IconCaret from '../../icons/IconCaret.vue';
import BannerHeader from '../BannerHeader.vue'

export default {

    components: {
        SideMenu,
        SideMenuContent,
        BannerHeader,
        IconCaret,
    },
    props: {
        routes: {
            type: Object,
            required: true
        },
        currentRoute: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            lastScroll: 0,
            defaultColor: null,
            currentColor: null,
            isActive: false,
            upperBand: false,
            delta: 30,
            vhCheck: {},
            currentColorTimeout: null,
            banner: {},
        };
    },
    computed: {
        isBanner() {
            return Object.keys(this.banner).length != 0
        },
        localeFormat() {
            var string = "";

            switch (window.appLocale) {
                case "es":
                    string = "Es";
                    break;
                case "en":
                    string = "En";
                    break;
                case "ca":
                    string = "Ca";
                    break;

                default:
                    string = "ES";
                    break;
            }
            return string.toUpperCase();
        }
    },
    watch: {
        isActive(isActive) {
            isActive ? this.openMenu() : this.closeMenu();
            if (! isActive) {
                this.$el.classList.remove('scroll-down');
                this.$el.classList.add(window.scrollY === 0 ? 'in-top' : 'scroll-up');
            }
        }
    },
    created() {
        const defaultColor = whiteAsDefault.includes(this.currentRoute)
            ? "white"
            : "rouge";
        this.defaultColor = this.currentColor = defaultColor;
        window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        isLinkActive(key) {
            if (this.currentRoute == "dishes" || this.currentRoute == "wines") {
                return key == "menu" ? true : false;
            }
            if (
                this.currentRoute == "products" ||
                this.currentRoute == "product"
            ) {
                return key == "products" ? true : false;
            }

            return key == this.currentRoute;
        },
        toggleMenu() {
            this.isActive = ! this.isActive;
        },
        openMenu() {
            this.vhCheck = vhCheck({
                updateOnTouch: true
            });
            this.isActive = true;
            document.documentElement.style.overflow = "hidden";
        },
        closeMenu() {
            this.isActive = false;
            document.documentElement.style.overflow = "visible";
            this.vhCheck = vhCheck({
                updateOnTouch: false
            });
            this.$el.querySelector(".nav-mobile").scrollTo(0, 0);
        },
        handleScroll(event) {
            if (this.isActive) {
                return;
            }
            const scrollUp = "scroll-up";
            const scrollDown = "scroll-down";
            const top = "in-top";
            const currentScroll = window.pageYOffset;
            const header = document.getElementById("header");
            if (currentScroll <= 0) {
                //in top
                if (this.currentColorTimeout) {
                    clearTimeout(this.currentColorTimeout);
                }
                this.currentColor = this.defaultColor;
                header.classList.remove(scrollUp);
                header.classList.add(top);
                return;
            }
            if (
                currentScroll > this.lastScroll &&
                currentScroll > this.delta
            ) {
                // scrolling down
                if (! this.currentColorTimeout) {
                    this.currentColorTimeout = setTimeout(() => {
                        this.currentColor = "rouge";
                    }, 300);
                }
                header.classList.remove(scrollUp);
                header.classList.remove(top);
                header.classList.add(scrollDown);
                header.classList.remove("header-top");
            } else if (
                currentScroll < this.lastScroll
            ) {
                // scrolling up
                if (this.currentColorTimeout) {
                    clearTimeout(this.currentColorTimeout);
                }
                this.currentColor = "rouge";
                header.classList.remove(scrollDown);
                header.classList.remove(top);
                header.classList.add(scrollUp);
                header.classList.add("header-top");
            }
            this.lastScroll = currentScroll;
        }
    },
    mounted() {
        
        const scrollIsZero = window.scrollY === 0;
        if (! scrollIsZero) {
            this.currentColor = 'rouge';
        }
        this.$nextTick(() => this.$el.classList.add(scrollIsZero ? 'in-top' : 'scroll-up'));
        window.addEventListener('DOMContentLoaded', () => {
            this.vhCheck = vhCheck({
                updateOnTouch: false
            });
        });
    },
    beforeMount() {
    axios
      .get('/api/banners')
      .then((res) => {
        this.banner = { ...res.data }
      })
      .catch((err) => {
        console.log(err)
      })
  },

};
</script>
<style lang="scss">
@import "../../../sass/variables";

.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    transition: transform 0.4s;
    background-color: transparent;
    z-index: 10000;

    &.bannermargin {
        height: 105px;
        @media (max-width: $breakpoint-landing-phone) {
        height: 98px;
        }
    }

    &.in-top {
        transition: background-color 0.5s ease-out;
    }

    .header-logo {
        .logo-operegrino {
            transition: width 0.4s ease;
            width: 128px;
            @media (min-width: 1024px) {
                width: 149px;
            }
        }
    }

    .header-links {
        justify-content: center;
        align-items: center;

        .link:hover {
            color: $primary !important;
        }

        a.active {
            border-bottom: 1px solid black;
        }

        @media (min-width: 1024px) {
            margin-right: 60px;
        }
        .cart-icon {
            position: relative;
            margin-right: 1rem;
            @media (min-width: 1024px) {
                margin-right: 0;
            }
        }
    }
    &-container {
        height: 58px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 2rem);
        margin: 0 auto;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;

        @media (min-width: 640px) {
            width: 90vw;
        }
        @media (min-width: 1024px) {
            height: 90px;
        }

        .btn-reservation {
            transition: opacity 0.3s ease-out, color 0.3s ease-out, border-color 0.3s ease-out;
            margin-right: 1.25rem;

            @media (min-width: 1024px) {
                margin-right: 2.25rem;
            }
        }

        .nv-link {
            @media (min-width: 1024px) {
                margin-left: 2rem;
            }
            &.user-icon {
                img {
                    width: 22px;
                    height: auto;
                }
            }
            &.cart-icon {
                img {
                    width: 24px;
                    height: auto;
                }
            }
        }
    }
    &:not(.open).scroll-down {
        transform: translate3d(0, -100%, 0);
        transition: 0.5s;
    }
    &.scroll-up {
        transform: none;
        color: black;
        background-color: $pale;
        transition: 0.5s;
    }
    #hamburger-icon {
        width: 32px;
        height: 44px;
        margin-top: 15px;
        position: relative;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: 0.3s ease-in-out;
        -moz-transition: 0.3s ease-in-out;
        -o-transition: 0.3s ease-in-out;
        transition: 0.3s ease-in-out;
        cursor: pointer;

        @media (min-width: 1024px) {
            width: 42px;
        }

        span {
            display: block;
            position: absolute;
            height: 3px;
            width: 100%;
            border-radius: 9px;
            opacity: 1;
            left: 0;
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transition: 400ms ease-in-out;
            -moz-transition: 400ms ease-in-out;
            -o-transition: 400ms ease-in-out;
            transition: 400ms ease-in-out;
            cursor: pointer;
        }

        &.white span {
            background-color: white;
        }
        &.rouge span {
            background-color: $rouge;
        }

        span:nth-child(1) {
            top: 0px;
        }

        --top-1: 12px;
        --top-2: 24px;

        span:nth-child(2),
        span:nth-child(3) {
            top: var(--top-1);
        }

        span:nth-child(4) {
            top: var(--top-2);
        }

        &.open span:nth-child(1) {
            top: var(--top-1);
            width: 0%;
            left: 50%;
        }

        &.open span:nth-child(2) {
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -o-transform: rotate(45deg);
            transform: rotate(45deg);
        }

        &.open span:nth-child(3) {
            -webkit-transform: rotate(-45deg);
            -moz-transform: rotate(-45deg);
            -o-transform: rotate(-45deg);
            transform: rotate(-45deg);
        }

        &.open span:nth-child(4) {
            top: var(--top-1);
            width: 0%;
            left: 50%;
        }
    }

    .language-selector-mobile {
        --bottom: 30px;
        position: absolute;
        bottom: calc(var(--bottom) + var(--vh-offset, 0px));
        left: 24px;
        right: 24px;
        text-align: center;

        @media (min-width: 768px) {
            --bottom: 60px;
        }
        @media (min-width: 1024px) {
            --bottom: 90px;
        }

        a {
            color: $rouge !important;
        }
    }

    &.open {
        transition: background-color 0.5s ease;
        background-color: $pale;

        #hamburger-icon span {
            background-color: $rouge;
        }
    }
}

.bannermargin {
  height: 110px;
}

.upper-fringe {
    position: fixed;
    background-color: $primary;
    color: $white;
    text-align: center;
    font-size: 14px;
    z-index: 10000;
}

// .header-top {
//     margin-top: 2.3rem;

//     @media(max-width: 1090px){
//         margin-top: 3.6rem;
//     }

//     @media(max-width: 564px){
//         margin-top: 4.9rem;
//     }

//     @media(max-width: 397px){
//         margin-top: 6.2rem;
//     }

//     @media(max-width: 314px){
//         margin-top: 7.5rem;
//     }
// }

</style>
